import moment from 'moment';
import globals from '../../../globals/communityGlobals';
import {
  ORG_UNITS_CURRENT_USER_GET_REQUEST,
  ORG_UNITS_CURRENT_USER_GET_SUCCESS,
  ORG_UNITS_CURRENT_USER_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';

function getCurrentUserOrgUnits(date) {
  return {
    types: [ORG_UNITS_CURRENT_USER_GET_REQUEST, ORG_UNITS_CURRENT_USER_GET_SUCCESS, ORG_UNITS_CURRENT_USER_GET_FAILURE],
    buildCallParameters: () => ({
      method: HTTP_METHOD.GET,
      path: `v1/query/GetCurrentUserTeamsOptions?relevantDay=${moment(date).format(globals.dateFormats.date)}`,
    }),
  };
}

export { getCurrentUserOrgUnits };
